<div class="page">
    <div class="page-body" *ngIf="response.status == 1">
        <div class="page-title">
            <div class="container">
                <h1 class="wow slideInDown">{{data.nome}}</h1>
            </div>    
        </div>
        <div class="page-content">
            <section class="descricao">
                <div class="container">
                    <article [innerHtml]="data.descricao | safeHtml"></article>
                </div>
            </section>
        </div>
    </div>
    <div class="page-body" *ngIf="response.status == 500">
        <page-error (reload)="getData()"></page-error>   
    </div>    
</div>        
<loader [hidden]="!loader" message="Carregando. Aguarde!"></loader> 